export default "__VITE_ASSET__pK2usvzZ__"